import {
    apiRequest,
    orangtuaList,
    orangtuaActive,
    orangtuaInactive
} from "../../../../../../services/adapters/kepegawaian/orangtuaService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", orangtuaList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", orangtuaInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", orangtuaActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository